module.exports = __webpack_public_path__ + "img/humanity.243f80e8.png";